module.exports = __webpack_public_path__ + "static/img/gallery.8085e9b0.png";